<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div id="div-anular" class="card w-100 px-3">
            <div class="row d-flex mt-3 mb-3 justify-content-center">
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-1">
                    <button
                        id="efectivo"
                        :class="
                        bottonActiveM == 'efectivo'
                            ? 'myButton active-btn w-100'
                            : 'myButton w-100'
                        "
                        @click="activarMedio('efectivo')"
                        :disabled="isGarantia || isplanilla"
                    >
                        <div
                        :class="
                            bottonActiveM == 'efectivo'
                            ? 'myButton-icon active-ico'
                            : 'myButton-icon'
                        "
                        >
                        <i class="far fa-money-bill-alt fa-2x mt-3"></i>
                        </div>
                        <div>Efectivo</div>
                    </button>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-1">
                    <button
                        id="tarjeta"
                        :class="
                        bottonActiveM == 'tarjeta'
                            ? 'myButton active-btn w-100'
                            : 'myButton w-100'
                        "
                        @click="activarMedio('tarjeta')"
                        :disabled="isGarantia || isplanilla"
                    >
                        <div
                        :class="
                            bottonActiveM == 'tarjeta'
                            ? 'myButton-icon active-ico'
                            : 'myButton-icon'
                        "
                        >
                        <i class="fas fa-credit-card fa-2x mt-3"></i>
                        </div>
                        <div>Tarjeta</div>
                    </button>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-1">
                    <button
                        id="deposito"
                        :class="
                        bottonActiveM == 'deposito'
                            ? 'myButton active-btn w-100'
                            : 'myButton w-100'
                        "
                        @click="activarMedio('deposito')"
                        :disabled="isGarantia || isplanilla"
                    >
                        <div
                        :class="
                            bottonActiveM == 'deposito'
                            ? 'myButton-icon active-ico'
                            : 'myButton-icon'
                        "
                        >
                        <i class="fas fa-money-check-alt fa-2x mt-3"></i>
                        </div>
                        <div>Deposito</div>
                    </button>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
                    <button
                        id="transferencia"
                        :class="
                        bottonActiveM == 'transferencia'
                            ? 'myButton active-btn w-100'
                            : 'myButton w-100'
                        "
                        @click="activarMedio('transferencia')"
                        :disabled="isGarantia || isplanilla"
                    >
                        <div
                        :class="
                            bottonActiveM == 'transferencia'
                            ? 'myButton-icon active-ico'
                            : 'myButton-icon'
                        "
                        >
                        <i class="fas fa-exchange-alt fa-2x mt-3"></i>
                        </div>
                        <div>Transferencia</div>
                    </button>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 mb-1">
                    <button
                        id="mixto"
                        :class="
                        bottonActiveM == 'mixto'
                            ? 'myButton active-btn w-100'
                            : 'myButton w-100'
                        "
                        :disabled="isplanilla"
                        @click="activarMedio('mixto')"
                    >
                        <div
                        :class="
                            bottonActiveM == 'mixto'
                            ? 'myButton-icon active-ico'
                            : 'myButton-icon'
                        "
                        >
                        <i class="fas fa-wallet fa-2x mt-3"></i>
                        </div>
                        <div>Mixto</div>
                    </button>
                </div>
            </div>
            <div class="row d-flex mt-3 mb-3 px-5 justify-content-center">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" v-if="bottonActiveM == 'efectivo'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">EFECTIVO</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text"
                        v-on:keypress="isNumber($event)" @blur="mtdCalculate('efectivo')"
                        v-model="pago.amount.efectivo" placeholder="S/0.00"/>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" v-if="bottonActiveM == 'mixto'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">EFECTIVO</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text"
                        v-on:keypress="isNumber($event)" @blur="mtdCalculate('mixto')"
                        v-model="pago.amount.efectivo" placeholder="S/0.00"/>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" v-if="bottonActiveM == 'efectivo'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">VUELTO</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text" disabled
                        v-model="pago.vuelto" placeholder="S/0.00"/>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2" v-if="bottonActiveM == 'tarjeta'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">TARJETA</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text" readonly
                        @blur="mtdCalculate('tarjeta')" v-model="cpTarjeta"/>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" v-if="bottonActiveM == 'mixto'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">TARJETA</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text"
                        v-on:keypress="isNumber($event)" @blur="mtdCalculate('mixto')"
                        v-model="pago.amount.tarjeta" placeholder="S/0.00"/>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2" v-if="bottonActiveM == 'deposito'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">DEPÓSITO</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text" readonly
                    @blur="mtdCalculate('deposito')" v-model="cpDeposito"/>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" v-if="bottonActiveM == 'mixto'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">DEPÓSITO</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text"
                        v-on:keypress="isNumber($event)" @blur="mtdCalculate('mixto')"
                        v-model="pago.amount.deposito" placeholder="S/0.00"/>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2" v-if="bottonActiveM == 'transferencia'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">TRANSFERENCIA</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text" readonly
                    @blur="mtdCalculate('transferencia')" v-model="cpTransferencia"/>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" v-if="bottonActiveM == 'mixto'">
                    <label for="mixto" class="form-label border-custom-text-2 fw-bold text-center d-block">TRANSFERENCIA</label>
                    <input class="form-control form-control-md text-center fw-bold" type="text"
                        v-on:keypress="isNumber($event)" @blur="mtdCalculate('mixto')" id="mixto"
                        v-model="pago.amount.transferencia" placeholder="S/0.00"/>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-2" v-if="bottonActiveM == 'efectivo' || bottonActiveM == 'mixto'">
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">TOTAL</label>
                    <input class="form-control form-control-md text-center fw-bold input_total" readonly type="text"
                        v-model="totalPay"/>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2" v-else >
                    <label class="form-label border-custom-text-2 fw-bold text-center d-block">TOTAL</label>
                    <input class="form-control form-control-md text-center fw-bold input_total" readonly type="text"
                        v-model="totalPay"/>
                </div>
            </div>
        </div>
        <template #footer>
            <button class="btn btn-success btn-sm" @click="mdtCommitPayment" :disabled="!procede">
               FINALIZAR
            </button>
        </template>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import {mapActions} from "vuex";

export default {
    name: "c-modal-orden-payment",
    components: {
        CModal,
        SweetAlert,
    },
    data() {
        return {
            swal: null,
            isplanilla:false,
            payment1: {},
            totalEnd: 0.0,
            bottonActiveM: "",
            bottonActiveT: "",
            bottonActiveP: "",
            garantia: false,
            pago: {
                method: "",
                amount: {
                    efectivo: 0,
                    tarjeta: 0,
                    deposito: 0,
                    transferencia: 0,
                    planilla: 0,
                },
                pending: 0,
                vuelto: 0,
            },
            procede: true,
            isGarantia: false,
        };
    },
    watch: {
        payload: {
            handler(newVal) {
            },
            immediate: true,
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
        totalPay: Number,
    },
    computed: {
        cpTarjeta() {
            this.pago.amount.tarjeta = this.totalPay;
            return this.pago.amount.tarjeta;
        },
        cpDeposito() {
            this.pago.amount.deposito = this.totalPay;
            return this.pago.amount.deposito;
        },
        cpTransferencia() {
            this.pago.amount.transferencia = this.totalPay;
            return this.pago.amount.transferencia;
        },
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdClose() {
            this.clear();
            this.$emit("closeModal");
        },
       
        clear() {
            this.bottonActiveM = "",
            this.bottonActiveT = "",
            this.bottonActiveP ="",
            this.garantia = false,
            this.pago = {
                method: "",
                amount: {
                    efectivo: 0,
                    tarjeta: 0,
                    deposito: 0,
                    transferencia: 0,
                    planilla: 0,
                },
                pending: 0,
                vuelto: 0,
            },
            this.procede =true
        },

        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        filterKey: function (e) {
            let b = false;
            b = /^[0-9]$/.test(e.key);
            if (b == false && e.key != "Backspace") {
                e.preventDefault();
            }
        },

        activarMedio(value) {
            this.pago.method = value;
            this.bottonActiveM = value;
            this.pago.amount = {
                efectivo: 0,
                tarjeta: 0,
                deposito: 0,
                transferencia: 0,
                planilla: 0,
            };
            this.pago.pending = 0;
            this.pago.vuelto = 0;
            if (value != "mixto") {
                this.garantia = false;
            }
            this.mtdCalculate(this.pago.method);
        },

        mtdCalculate(input) {
            if (!this.pago.method) {
                Swal.fire({
                    text: "Escoga un tipo Metodo de Pago",
                    icon: "warning",
                    confirmButtonColor: "#43517A",
                });
                return;
            }
            
            let acum = 0;
            this.procede = false;
            
            if (input === "efectivo") {
                acum = parseFloat(this.pago.amount.efectivo) || 0;
            } else if (["tarjeta", "deposito", "transferencia", "planilla"].includes(input)) {
                acum = parseFloat(this.totalPay) || 0;
            } else if (input === "mixto") {
                acum = ["efectivo", "tarjeta", "deposito", "transferencia", "planilla"].reduce((sum, method) => 
                    sum + (parseFloat(this.pago.amount[method]) || 0), 0);
            }
            
            let dif = acum - this.totalPay;
            
            if (this.isGarantia && acum > 0) {
                this.payment1 = { ...this.pago };
                this.procede = true;
                return;
            }
            
            if (this.pago.method === "mixto") {
                if (acum == this.totalPay) {
                        this.payment1 = { ...this.pago };
                        this.procede = true;
                    }
                if (acum > this.totalPay) {
                        this.$refs.SweetAlert.showWarning("El Monto Ingresado tiene que ser S/."+this.totalPay, "warning");
                        return;
                }
                return;
            }
            
            if (dif >= 0) {
                this.procede = true;
                this.pago.vuelto = dif.toFixed(2);
                this.payment1 = { ...this.pago };
            }
        },

        mdtCommitPayment() {
            if (!this.mtdVerifmedio()) {
                this.$refs.SweetAlert.showWarning("Escoga un medio de Pago", "warning");
                return;
            }

            if (!this.procede) {
                this.$refs.SweetAlert.showWarning("El Monto Ingresado no es Válido", "warning");
                return;
            }
            this.$emit("mdtCommitPayment", this.pago);
        },

        mtdVerifmedio: function () {
            if (this.bottonActiveM != "" && this.pago.method != "") return true;
            return false;
        },
    },
};
</script>
<style scoped>
@media (max-width: 1199px) {
  .myButton-icon {
    margin: 0px 20px 0px 20px;
  }

  .myButton-icon-2 {
    margin: 0px 3px 0px 3px;
  }

  #row-3 {
    align-content: center;
    margin: 0;
  }
}

@media (max-width: 991px) {
  #row-3 {
    flex-wrap: wrap;
  }

  .col {
    flex-basis: 50%;
  }

  #row {
    flex-direction: column;
  }

  .border-right {
    border-right: none;
    border-bottom: 1.5px solid #43517A;
  }

  #row-3 {
    align-content: center;
    margin: 0;
  }
}

@media (max-width: 767px) {
  #row-2 {
    flex-direction: column;
    align-content: center;
  }

  #row-3 {
    align-content: center;
    margin: 0;
  }

  .myButton-icon-2 {
    margin: 0px -11px 0px -11px;
  }

  .myButton-icon {
    margin: 0px 70px 0px 70px;
  }
}

@media (max-width: 575px) {
  .myButton-icon {
    margin: 0px 78px 0px 78px;
  }
}

@media (max-width: 531px) {
  .myButton-icon {
    margin: 0px 0px 0px 0px;
  }

  .myButton-icon-2 {
    margin: 0px -40px 0px -40px;
  }
}

@media (max-width: 414px) {
  .col2 {
    padding: 0px 15px 0px 15px;
  }

  .button-1 {
    margin-bottom: 15px !important;
  }
}
</style>
